<div class="btn-toolbar d-flex justify-content-between mb-2 qa-item">
  <div class="input-group">
    <select class="custom-select variable-select" [(ngModel)]="expr.variable" (change)="onVariableChange()">
      <option *ngFor="let v of variables" [value]="v.name">{{v.name}}</option>
    </select>

    <select class="custom-select qa-bg-gray operator" [(ngModel)]="expr.operator" (change)="onExprChange()">
      <option value=">">&gt;</option>
      <option value="<">&lt;</option>
      <option value=">=">&gt;=</option>
      <option value="<=">&lt;=</option>
      <option value="==">==</option>
      <option value="!=">!=</option>
    </select>

    <ng-container [ngSwitch]="currentType">
      <input *ngSwitchCase="'number'" class="form-control" type="number" [(ngModel)]="expr.value" (keyup)="onExprChange()" (blur)="onExprChange()" />
      <input *ngSwitchCase="'string'" class="form-control" type="text" [(ngModel)]="expr.value" (keyup)="onExprChange()" (blur)="onExprChange()" />
      <select *ngSwitchCase="'boolean'" class="custom-select" [(ngModel)]="expr.value" (change)="onExprChange()">
        <option [ngValue]="true">true</option>
        <option [ngValue]="false">false</option>
      </select>
      <ng-container *ngSwitchCase="'date'">
        <ng-container *ngIf="supportsInputDate()">
          <input
            #dateField
            class="form-control"
            type="date"
            [value]="expr?.value || ''"
            (change)="onDateComplete(dateField.value)"
          />
        </ng-container>
        <ng-container *ngIf="!supportsInputDate()">
          <input
            type="text"
            class="form-control"
            [value]="getDisplayDate()"
            [imask]="iMaskOptions"
            [unmask]="true"
            (complete)="onDateComplete()"
          />
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
  <button class="btn btn-danger ml-1" (click)="exprDelete.emit()">
    <i class="fa fa-trash"></i>
  </button>
</div>


